(function() {

  class Accordion {
    constructor(element) {
      if(!element || element.classList.contains('u-module--initialized')) return;

      element.classList.add('u-module--initialized');

      this.element = element;
      this.wrapper = element.closest('.u-accordion__wrapper');
      this.items = element.querySelectorAll('.u-accordion__item');
      this.init();
      element.dataset.accordionInstance = this;

      var event = new CustomEvent('generate-smooth-scroll-links', { detail: element });
      document.dispatchEvent(event);
    }

    init() {
      for(let i=0; i<this.items.length; i++) {
        this.initItem(this.items[i]);
      }

      const showMore = this.wrapper.querySelector('.u-accordion__show-more');
      if(showMore) {
        showMore.addEventListener('click', () => {
          this.wrapper.classList.add('u-accordion--show-hidden')
        });
      }
      
      const showLess = this.wrapper.querySelector('.u-accordion__show-less');

      if (showLess) {
        showLess.addEventListener('click', () => {
          this.wrapper.classList.remove('u-accordion--show-hidden')
        });
      }
    }
    initItem(item) {

      const header = item.querySelector('.u-accordion__item-header');
      const button = item.querySelector('.u-accordion__toggle-button');
      const parallaxWrapper = this.element.closest('.u-parallax');

      function openItem(item) {
        item.classList.toggle('is-open');
        if(parallaxWrapper) {
          var event = new CustomEvent('parallax-height-adujust', { detail: {
            callback: () => {
              const parallaxContent = parallaxWrapper.closest('.u-parallax__content');
              let itemScrollOffset = 0;
              if(parallaxContent) {
                itemScrollOffset = item.offsetTop - parallaxContent.offsetTop;
              }

              gsap.to(window, {duration: 0, scrollTo: {
                y: item, 
                offsetY: document.querySelector('.u-header').offsetHeight - parseInt(window.getComputedStyle(item).marginTop + itemScrollOffset) - 20
              }});
            }
          }});
          parallaxWrapper.dispatchEvent(event);
        }
      }

      header.addEventListener('click', (e) => {
        // ignore click on button
        if(e.target.closest('.u-accordion__toggle-button')) return;

        openItem(item);
      })

      button.addEventListener('click', () => {
        openItem(item);
      })
    }
  }

  function initAll(parent) {
    const elements = parent.querySelectorAll('.u-accordion');

    for (const element of elements) {
      new Accordion(element)
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
  });

  document.addEventListener('overlay-content-ready', function () {
    initAll(document.querySelector('.u-overlay__content'));
  });

})();